import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TitleService } from '../shared/title.service';
import { UserService } from '../user/user.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  standalone: false
})
export class VerifyEmailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);
  private titleService = inject(TitleService);

  token = '';
  username = '';
  isLoading = true;
  status = false;

  ngOnInit() {
    this.titleService.setTitle('Verify Email');
    this.token = this.route.snapshot.queryParams['token'];
    this.username = this.route.snapshot.queryParams['username'];
    this.verify();
  }

  verify() {
    this.isLoading = true;
    this.userService.verify(this.token, this.username).subscribe({
      next: () => {
        this.isLoading = false;
        this.status = true;
      },
      error: () => {
        this.isLoading = false;
        this.status = false;
      }
    });
  }
}
